import { useQuery } from '@tanstack/react-query';
import { getStockLevels } from '../api';
import type { StockFilters } from '../types';

export const STOCK_LEVELS_QUERY_KEY = 'stockLevels';

interface UseStockLevelsOptions {
  siteId: string;
  filters?: StockFilters;
  enabled?: boolean;
}

/**
 * Hook for fetching stock levels with TanStack Query.
 * Handles caching, refetching, and error states.
 */
export function useStockLevels({
  siteId,
  filters,
  enabled = true,
}: UseStockLevelsOptions) {
  return useQuery({
    queryKey: [STOCK_LEVELS_QUERY_KEY, siteId, filters],
    queryFn: () => getStockLevels(siteId, filters),
    enabled: enabled && Boolean(siteId),
    staleTime: 30_000,
    gcTime: 5 * 60 * 1000,
  });
}
